/**
 * @Author: wuyang
 * @Date: 2024/1/8
 * @Description: ""
 */
import { ComponentType, lazy, Suspense } from 'react'
import { ReactComponent as LogoFill } from '@/asset/svg/logo-fill.svg'

export const getLazy = (
	callback: () => Promise<{
		default: ComponentType<any>
	}>
) => {
	const LazyComp = lazy(callback)
	return () => (
		<Suspense
			fallback={
				<div className={'flex w-full h-full pt-[150px] justify-center items-center'}>
					<div className={'w-[160px] h-[160px]'}>
						<LogoFill fill={'#bbbbbb'} />
					</div>
				</div>
			}
		>
			<LazyComp />
		</Suspense>
	)
}
